// extracted by mini-css-extract-plugin
export var faqs = "legal-module--faqs--85cd6";
export var layout = "legal-module--layout--258ec";
export var legalOverrides = "legal-module--legal-overrides--ca7ac";
export var mainH1 = "legal-module--main-h1--62b1b";
export var menu = "legal-module--menu--24d67";
export var secondaryH1 = "legal-module--secondary-h1--f675e";
export var sticky = "legal-module--sticky--ec29c";